import * as React from "react"
import SEO from "../components/SEO"
import Layout from "../layout/Layout"
import Main from "../layout/Main/Main"
// Fonts
import "fontsource-lato/900.css" // Only needed for headings
import "fontsource-open-sans/400.css" // Weight 400.
import "fontsource-open-sans/400-italic.css" // Loads the italic variant
import "fontsource-open-sans/800.css" // Bold
// Styles
import "../styles/style.scss"
// Background
import bg from "../images/homeBg.png"

const IndexPage = (props) => {
  return (
    <Layout bg={bg} bgAlt="Fabricsthan">
      <SEO title="Fabricsthan | Fabrics of India" />
      <Main {...props} />
    </Layout>
  )
}

export default IndexPage
